import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';

export const Wrapper = styled(Box)`
  margin-bottom: ${({ theme }) => theme.spacing(1)};
`;

export const Border = styled(Box)`
  ${({ theme }) => css`
    margin-top: ${theme.spacing(2)};
    border-top: 1px solid ${theme.colors.primaryAdd6};
  `}
`;
